import LatLng from "./LatLng";

export default class ViaeLocation {
  constructor(private readonly _id: string,
              private readonly _name: string,
              private readonly _position: LatLng) {
  }

  get id(): string {
    return this._id;
  }

  get name(): string {
    return this._name;
  }

  get position(): LatLng {
    return this._position;
  }
}
